<nav class="navbar navbar-expand-lg bg-light">
    <div class="container-fluid">
        <a class="navbar-brand" [routerLink]="['/']">
            <img src="./assets/img/austrotherm.png" class="me-2" style="height: 46px">
            Projektverwaltung
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link" [routerLinkActive]="'active'" [routerLink]="['/project']"><i class="fas fa-file-lines me-2"></i>Projekte</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLinkActive]="'active'" [routerLink]="['/light']"><i class="far fa-file-lines me-2"></i>Projekte Light</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLinkActive]="'active'" [routerLink]="['/overview']"><i class="fas fa-chart-gantt me-2"></i>Projektübersicht</a>
                </li>
                @if (accessService.hasRights([Right.PLANT_MANAGEMENT, Right.RAD_STAFF])) {
                    <li class="nav-item">
                        <a class="nav-link" [routerLinkActive]="'active'" [routerLink]="['/research']"><i class="fas fa-file-contract me-2"></i>Projekte F&E</a>
                    </li>
                }
                <li class="nav-item">
                    <a class="nav-link" [routerLinkActive]="'active'" [routerLink]="['/templates']"><i class="fas fa-file me-2"></i>Vorlagen</a>
                </li>
            </ul>

            <span class="navbar-text ms-auto" placement="bottom" [tooltip]="onlineTemplate">{{ online.length }} Benutzer online</span>

            <span class="navbar-text ms-3 me-2">
                (v{{currentApplicationVersion}})
            </span>

            <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        {{ accessService.user?.name }}
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li><a class="dropdown-item" [routerLink]="['/settings']">
                            <i class="fa-solid fa-cogs"></i> Einstellungen
                        </a></li>
                        <li><a class="dropdown-item" *ngIf="accessService.hasRights([Right.EDIT_MASTER_DATA])" [routerLink]="['/user']">
                            <i class="fa-solid fa-users"></i> Benutzer
                        </a></li>
                        <li><a class="dropdown-item" *ngIf="accessService.hasRights([Right.EDIT_MASTER_DATA])" [routerLink]="['/country']">
                            <i class="fa-solid fa-globe"></i> Länder
                        </a></li>
                        <li><a class="dropdown-item" *ngIf="accessService.hasRights([Right.EDIT_MASTER_DATA])" [routerLink]="['/department']">
                            <i class="fa-solid fa-building"></i> Abteilungen
                        </a></li>
                        <li><a class="dropdown-item" *ngIf="accessService.hasRights([Right.EDIT_MASTER_DATA])" [routerLink]="['/region']">
                            <i class="fa-solid fa-map"></i> Länderbereiche
                        </a></li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>

<ng-template #onlineTemplate><div [innerHtml]="onlineNames"></div></ng-template>
